export default {
  START: '/',
  LOGIN: '/login',
  BB_APP: '/app',
  WELCOME: '/welcome',
  LEVELS: '/levels',
  COURSES_PERSONALIZED: '/courses_personalized',
  COURSES_PERSONALIZED_WIZARD: '/courses_personalized_wizard',
  RAPID_TEST_INSTRUCTIONS: '/rapid_test_instructions',
  RAPID_TEST_RESULTS: '/rapid_test_results',
  RAPID_TEST: '/rapid_test',
  LEVELS_PERSONALIZED: '/levels_personalized',
  UNITS: '/units',
  LESSONS: '/lessons',
  AUDIO: '/audio',
  QUIZZES: '/quizzes',
  DRILLS: '/drills',
  DRILL_FLASHCARDS: '/flashcards',
  DRILL_VOICECOMPARISON: '/voice_comparison',
  DRILL_PRONUNCIATIONANALYSIS: '/pronunciation_analysis',
  DRILL_VIDEO: '/video',
};
